import { useAtomValue } from 'jotai';

import bubbleJoyLogo from '@rewardopl/assets/logos/bubblejoy.svg';

import { Image, Wrapper } from './vendor_logo.styles';

import { modeState } from '../../store';

import { VENDOR_BUSINESS_NAME } from '../../constants';

import bubblejoyTaiwanLogo from '../../static/bubblejoy-taiwan.svg';

type VendorLogoProps = { width?: number };

export default function VendorLogo({ width = 175 }: VendorLogoProps) {
  const mode = useAtomValue(modeState);

  const height = width * ((mode === 'bubblejoy' ? 180 : 217.142) / 500);

  return (
    <Wrapper>
      <Image
        alt={VENDOR_BUSINESS_NAME}
        height={height}
        src={mode === 'bubblejoy' ? bubbleJoyLogo : bubblejoyTaiwanLogo}
        width={width}
      />
    </Wrapper>
  );
}
